import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./Price.module.scss";
import { StrikethroughPrice } from "@/components/shared";

export type HotelPriceTextProps = PlatformComponentProps & {
  showPointsPricing: boolean;
  totalPoints: string;
  totalPrice: string;
  totalNights: number;
  rooms?: number;
  pricePerNightText: string;
  totalPriceNotDiscounted?: string | null;
};

export const HotelPriceText = ({
  showPointsPricing,
  totalPoints,
  totalPrice,
  totalNights,
  rooms = 1,
  pricePerNightText,
  totalPriceNotDiscounted,
}: HotelPriceTextProps) => {
  const { t } = useI18nContext();
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelCardPrice,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelCardPrice);

  const totalPriceString = showPointsPricing ? (
    <Trans
      i18nKey="core-hotels.availabilityPage.results.hotelCard.price.totalPointsWithTaxesAndFees"
      values={{
        points: totalPoints,
        nights: totalNights,
        count: rooms,
      }}
      components={[<span className={cn("price-description")} />]}
    />
  ) : (
    <Trans
      i18nKey="core-hotels.availabilityPage.results.hotelCard.price.totalPriceWithTaxesAndFees"
      values={{
        price: totalPrice,
        nights: totalNights,
        count: rooms,
      }}
      components={[<span className={cn("price-description")} />]}
    />
  );

  return (
    <div className={clsx(block, cn("price-container"))}>
      <div className={cn("price-per-night")}>
        <span className={cn("total-price-per-night")}>{pricePerNightText}</span>
      </div>
      <span className={cn("total-price")}>
        {totalPriceNotDiscounted && (
          <StrikethroughPrice price={totalPriceNotDiscounted} />
        )}
        {totalPriceString}
      </span>
      {showPointsPricing && (
        <span className={cn("total-price-description")}>
          {t(
            "core-hotels.availabilityPage.results.hotelCard.price.totalPriceDescription",
            {
              price: totalPrice,
            }
          )}
        </span>
      )}
    </div>
  );
};
